import { render } from "./CategoryIndex.vue?vue&type=template&id=831e9f5c&ts=true"
import script from "./CategoryIndex.vue?vue&type=script&lang=ts"
export * from "./CategoryIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__